export default "__VITE_ASSET__C0poL5wP__";